import { VendorJobRequestPage } from "../vendor-job-request.page";
import { useCentralStore } from "../../../store/Central";

export const VendorJobRequestPageConnected = () => {
	const { organizationId, organizationName } = useCentralStore((s) => ({
		organizationId: s.organization?.id ?? "",
		organizationName: s.organization?.name ?? "",
	}));

	return (
		<VendorJobRequestPage
			organizationId={organizationId}
			organizationName={organizationName}
		/>
	);
};
